import { useEffect, useState } from "react";

import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";

import { Button } from "@mui/material";
import { PageContainer } from "@/features/ui";

import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { CenteredLoading, useSnackbar } from "@/features/ui";
import { PurchaseOrderLabForm } from "@/features/purchase-orders";

export const EditPurchaseOrderLab = () => {
  const { referenceNumber } = useParams();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    const fetchPurchaseOrder = async () => {
      setIsLoading(true);
      try {
        const {
          data: { data },
        } = await apiOutletClient.get(
          `purchase-orders/lab/${referenceNumber}`,
          {
            params: {
              withBuyer: true,
              withSeller: true,
              withWarehouse: true,
              withProductVariants: true,
              withPaymentTerm: true,
              withCreator: true,
            },
          }
        );

        setDefaultValues({
          seller: data.seller,
          paymentTerm: data.paymentTerm,
          sellerableType: data.sellerableType,
          taxable: data.taxable,
          totalIncludesTax: data.totalIncludesTax,
          transactionDate: dayjs(data.transactionDate),
          warehouse: data.warehouse,
          buyer: data.buyer,
          note: data.note,
          taxAmount: data.taxAmount,
          taxPercentage: data.taxPercentage,
          discountInput: data.discountAmount || 0,
          discountType: data.discountType,
          subtotal: data.subtotal,
          grandTotal: data.grandTotal,
          purchaseOrderProductVariants: data.purchaseOrderProductVariants,
        });
      } catch (error) {
        showSnackbar(
          getErrorMessage(error, "Gagal memperbarui pesanan pembelian lensa")
        );
      } finally {
        setIsLoading(false);
      }
    };
    fetchPurchaseOrder();
  }, [referenceNumber, showSnackbar]);

  const handleSubmit = async (formPayload) => {
    try {
      const payload = {
        sellerableId: formPayload.sellerableId,
        paymentTermId: formPayload.paymentTermId,
        note: formPayload.note,
      };
      await apiOutletClient.patch(
        `purchase-orders/lab/${referenceNumber}`,
        payload
      );
      showSnackbar("Pesanan pembelian lab berhasil diperbarui", "success");
      navigate(-1);
    } catch (error) {
      showSnackbar(
        getErrorMessage(error, "Gagal memperbarui pesanan pembelian lensa")
      );
    }
  };

  if (!defaultValues && isLoading) {
    return <CenteredLoading />;
  }

  return (
    <PageContainer
      maxWidth="xl"
      title="Ubah Pesanan Pembelian Lab"
      breadcrumbs={[
        {
          title: "Pesanan Pembelian Lab",
          path: "/procurement/purchase-orders/lab",
        },
        {
          title: referenceNumber,
          path: `/procurement/purchase-orders/lab/${referenceNumber}`,
        },
        { title: "Ubah" },
      ]}
    >
      <PurchaseOrderLabForm
        editMode={true}
        isLoading={isLoading}
        defaultValues={defaultValues}
        onSubmit={handleSubmit}
        renderActionButton={({ isSubmitting }) => (
          <Button type="submit" variant="contained" loading={isSubmitting}>
            Simpan
          </Button>
        )}
      />
    </PageContainer>
  );
};
